import { render, staticRenderFns } from "./dolgi_firma.vue?vue&type=template&id=708ac96c&scoped=true&"
import script from "./dolgi_firma.vue?vue&type=script&lang=js&"
export * from "./dolgi_firma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ac96c",
  null
  
)

export default component.exports